import React from 'react';
import {useIntl} from 'react-intl';

import Typography from 'brandComponents/Typography';

import {IProductPreOrderProps} from './IProductPreOrder';
import messages from './messages';

const ProductPreOrder = ({element, classNames}: IProductPreOrderProps) => {
	const intl = useIntl();

	return (
		<Typography variant={element} classNames={classNames}>
			{intl.formatMessage(messages.preOrder)}
		</Typography>
	);
};

export default ProductPreOrder;
